import { render, staticRenderFns } from "./FamilyResidence.vue?vue&type=template&id=6afdc0eb"
import script from "./FamilyResidence.vue?vue&type=script&lang=js"
export * from "./FamilyResidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports